import { walletIds, SafeSupportedChainsSet, SafeWallet } from '@thirdweb-dev/wallets';
import { useWallet, useConnect, useChain, useChainId, useConnectionStatus, useSupportedChains, useSwitchChain, useDisconnect } from '@thirdweb-dev/react-core';
import { B as BackButton, I as Img, M as ModalTitle, a as ModalDescription, W as WalletSelection, H as HelperLink, u as useIsHeadlessWallet, h as FormField, d as defaultWallets, b as HeadlessConnectUI } from './headlessConnectUI-e724ea38.browser.esm.js';
import { useState } from 'react';
import styled from '@emotion/styled';
import { s as spacing, i as iconSize, S as Spacer, a as Flex, B as Button, f as fontSize, L as Label, E as ErrorMessage, b as Spinner } from './basic-72632cb3.browser.esm.js';
import { jsxs, jsx, Fragment } from 'react/jsx-runtime';
import { ChevronDownIcon, ExclamationTriangleIcon } from '@radix-ui/react-icons';
import { utils } from 'ethers';
import 'detect-browser';
import '@emotion/react';
import 'react-qr-code';
import '@radix-ui/react-dialog';
import '@radix-ui/colors';

function Steps(_ref) {
  let {
    step
  } = _ref;
  return /*#__PURE__*/jsxs(StepContainer, {
    children: [/*#__PURE__*/jsx(Circle, {
      "data-active": true
    }), /*#__PURE__*/jsx(Line, {
      "data-active": step === 2
    }), /*#__PURE__*/jsx(Circle, {
      "data-active": step === 2
    })]
  });
}
const StepContainer = styled.div`
  display: flex;
  align-items: center;
  width: 130px;
  padding: ${spacing.xs};
`;
const Circle = styled.div`
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background-color: ${p => p.theme.bg.highlighted};
  box-shadow: 0 0 0 3px ${p => p.theme.bg.base},
    0 0 0 5px ${p => p.theme.bg.highlighted};

  &[data-active="true"] {
    background-color: ${p => p.theme.link.primary};
    box-shadow: 0 0 0 3px ${p => p.theme.bg.base},
      0 0 0 5px ${p => p.theme.link.primary};

    position: relative;
    z-index: 2;
  }
`;
const Line = styled.div`
  flex-grow: 1;
  height: 4px;
  background-color: ${p => p.theme.bg.highlighted};
  &[data-active="true"] {
    background-color: ${p => p.theme.link.primary};
  }
`;

const SelectpersonalWallet = props => {
  const guestWallet = props.personalWallets.find(w => w.id === walletIds.localWallet);
  const personalWallets = props.personalWallets.filter(w => w.id !== walletIds.localWallet);
  return /*#__PURE__*/jsxs(Fragment, {
    children: [props.renderBackButton && /*#__PURE__*/jsx(BackButton, {
      onClick: props.onBack
    }), /*#__PURE__*/jsx(IconContainer, {
      children: /*#__PURE__*/jsx(Img, {
        src: props.safeWallet.meta.iconURL,
        width: iconSize.xl,
        height: iconSize.xl
      })
    }), /*#__PURE__*/jsx(Spacer, {
      y: "lg"
    }), /*#__PURE__*/jsx(ModalTitle, {
      children: "Link Personal Wallet"
    }), /*#__PURE__*/jsx(Spacer, {
      y: "sm"
    }), /*#__PURE__*/jsx(ModalDescription, {
      children: "Select a personal wallet to connect to your Safe"
    }), /*#__PURE__*/jsx(Spacer, {
      y: "xl"
    }), /*#__PURE__*/jsx(Steps, {
      step: 1
    }), /*#__PURE__*/jsx(Spacer, {
      y: "lg"
    }), /*#__PURE__*/jsx(WalletSelection, {
      walletConfigs: personalWallets,
      selectWallet: props.selectWallet
    }), /*#__PURE__*/jsx(Spacer, {
      y: "xl"
    }), guestWallet ? /*#__PURE__*/jsx(Flex, {
      justifyContent: "center",
      children: /*#__PURE__*/jsx(Button, {
        variant: "link",
        onClick: () => {
          props.selectWallet(guestWallet);
        },
        "data-test": "continue-as-guest-button",
        children: "Continue as guest"
      })
    }) : /*#__PURE__*/jsx(HelperLink, {
      target: "_blank",
      href: "https://docs.safe.global/learn/what-is-a-smart-contract-account",
      style: {
        textAlign: "center"
      },
      children: "What is a Safe?"
    })]
  });
};
const IconContainer = styled.div`
  margin-top: ${spacing.lg};
`;

const gnosisAddressPrefixToChainId = {
  eth: 1,
  matic: 137,
  avax: 43114,
  bnb: 56,
  oeth: 10,
  gor: 5
};
const SelectAccount = props => {
  const activeWallet = useWallet();
  const connect = useConnect();
  const activeChain = useChain();
  const connectedChainId = useChainId();
  const [safeAddress, setSafeAddress] = useState("");
  const [safeChainId, setSafeChainId] = useState(-1);
  const [safeConnectError, setSafeConnectError] = useState(false);
  const [switchError, setSwitchError] = useState(false);
  const [switchingNetwork, setSwitchingNetwork] = useState(false);
  const connectionStatus = useConnectionStatus();
  const requiresConfirmation = !useIsHeadlessWallet();
  const chains = useSupportedChains();

  // put supported chains first
  const supportedChains = chains.filter(c => SafeSupportedChainsSet.has(c.chainId));
  const selectedSafeChain = supportedChains.find(c => c.chainId === safeChainId);
  const testnets = supportedChains.filter(c => c.testnet);
  const mainnets = supportedChains.filter(c => !c.testnet);

  // if there are more than one mainnet and testnet, group them
  const useOptGroup = mainnets.length > 0 && testnets.length > 0;
  const handleSubmit = async () => {
    if (!selectedSafeChain || !activeWallet || !activeChain) {
      return;
    }
    setSafeConnectError(false);
    try {
      await connect(props.safeWalletConfig, {
        chain: selectedSafeChain,
        personalWallet: activeWallet,
        safeAddress
      });
      props.onConnect();
    } catch (e) {
      console.error(e);
      setSafeConnectError(true);
    }
  };
  const mismatch = safeChainId !== -1 && connectedChainId !== safeChainId;
  const isValidAddress = utils.isAddress(safeAddress);
  const disableNetworkSelection = supportedChains.length === 1;
  const switchChain = useSwitchChain();
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx(BackButton, {
      onClick: props.onBack
    }), /*#__PURE__*/jsx(Spacer, {
      y: "md"
    }), /*#__PURE__*/jsx(Img, {
      src: props.safeWalletConfig.meta.iconURL,
      width: iconSize.xl,
      height: iconSize.xl
    }), /*#__PURE__*/jsx(Spacer, {
      y: "lg"
    }), /*#__PURE__*/jsx(ModalTitle, {
      children: "Enter your Safe Address & Network "
    }), /*#__PURE__*/jsx(Spacer, {
      y: "md"
    }), /*#__PURE__*/jsxs(ModalDescription, {
      children: ["You can find your safe address in", " ", /*#__PURE__*/jsx(HelperLink, {
        target: "_blank",
        href: "https://app.safe.global/home",
        style: {
          display: "inline"
        },
        children: "Safe Dashboard"
      })]
    }), /*#__PURE__*/jsx(Spacer, {
      y: "lg"
    }), /*#__PURE__*/jsx(Steps, {
      step: 2
    }), /*#__PURE__*/jsx(Spacer, {
      y: "xl"
    }), /*#__PURE__*/jsxs("form", {
      onSubmit: e => {
        e.preventDefault();
        handleSubmit();
      },
      children: [/*#__PURE__*/jsx(FormField, {
        name: "safeAddress",
        id: "safeAddress",
        errorMessage: safeAddress && !isValidAddress ? "Invalid Safe Address" : undefined,
        autocomplete: "on",
        onChange: value => {
          setSafeConnectError(false);
          if (value.length > 4) {
            const prefix = value.split(":")[0];
            if (prefix && prefix in gnosisAddressPrefixToChainId) {
              setSafeChainId(gnosisAddressPrefixToChainId[prefix]);
              setSafeAddress(value.slice(prefix.length + 1));
            } else {
              setSafeAddress(value);
            }
          } else {
            setSafeAddress(value);
          }
        },
        label: "Safe Address",
        type: "text",
        value: safeAddress,
        required: true,
        placeholder: "0x123..."
      }), /*#__PURE__*/jsx(Spacer, {
        y: "lg"
      }), /*#__PURE__*/jsx(Label, {
        htmlFor: "safeNetwork",
        children: "Safe Network"
      }), /*#__PURE__*/jsx(Spacer, {
        y: "xs"
      }), /*#__PURE__*/jsxs("div", {
        style: {
          position: "relative"
        },
        children: [/*#__PURE__*/jsxs(NetworkSelect, {
          "data-error": supportedChains.length === 0,
          required: true,
          name: "safeNetwork",
          id: "safeNetwork",
          value: safeChainId,
          disabled: disableNetworkSelection,
          placeholder: "Select Network your safe is deployed to",
          onChange: e => {
            setSafeConnectError(false);
            setSwitchError(false);
            setSafeChainId(Number(e.target.value));
          },
          children: [!disableNetworkSelection && /*#__PURE__*/jsx("option", {
            value: "",
            hidden: true,
            children: "Select network your safe is deployed on"
          }), useOptGroup ? /*#__PURE__*/jsxs(Fragment, {
            children: [/*#__PURE__*/jsx("optgroup", {
              label: "Mainnets",
              children: mainnets.map(chain => {
                return /*#__PURE__*/jsx("option", {
                  value: chain.chainId,
                  children: chain.name
                }, chain.chainId);
              })
            }), /*#__PURE__*/jsx("optgroup", {
              label: "Testnets",
              children: testnets.map(chain => {
                return /*#__PURE__*/jsx("option", {
                  value: chain.chainId,
                  children: chain.name
                }, chain.chainId);
              })
            })]
          }) : supportedChains.map(chain => {
            return /*#__PURE__*/jsx("option", {
              value: chain.chainId,
              children: chain.name
            }, chain.chainId);
          })]
        }), !disableNetworkSelection && /*#__PURE__*/jsx(StyledChevronDownIcon, {
          width: iconSize.sm,
          height: iconSize.sm,
          style: {
            position: "absolute",
            top: "50%",
            right: spacing.sm,
            transform: "translateY(-50%)",
            pointerEvents: "none"
          }
        })]
      }), supportedChains.length === 0 && /*#__PURE__*/jsxs(Fragment, {
        children: [/*#__PURE__*/jsx(Spacer, {
          y: "sm"
        }), /*#__PURE__*/jsxs(ErrorMessage, {
          children: [" ", "Can not use Safe: No Safe supported chains are configured in App"]
        })]
      }), /*#__PURE__*/jsx(Spacer, {
        y: "sm"
      }), safeConnectError && /*#__PURE__*/jsxs(ErrorMessage, {
        style: {
          display: "flex",
          gap: spacing.sm,
          alignItems: "center",
          fontSize: fontSize.sm
        },
        children: [/*#__PURE__*/jsx(ExclamationTriangleIcon, {
          width: iconSize.sm,
          height: iconSize.sm
        }), /*#__PURE__*/jsxs("span", {
          children: ["Could not connect to Safe. ", /*#__PURE__*/jsx("br", {}), "Make sure safe address and network are correct."]
        })]
      }), switchError && /*#__PURE__*/jsxs(ErrorMessage, {
        style: {
          display: "flex",
          gap: spacing.sm,
          alignItems: "center",
          fontSize: fontSize.sm
        },
        children: [/*#__PURE__*/jsx(ExclamationTriangleIcon, {
          width: iconSize.sm,
          height: iconSize.sm
        }), /*#__PURE__*/jsx("span", {
          children: "Failed to switch network."
        })]
      }), /*#__PURE__*/jsx(Spacer, {
        y: "xl"
      }), /*#__PURE__*/jsx("div", {
        style: {
          display: "flex",
          justifyContent: "flex-end"
        },
        children: mismatch ? /*#__PURE__*/jsxs(Button, {
          type: "button",
          variant: "secondary",
          style: {
            display: "flex",
            alignItems: "center",
            gap: spacing.sm
          },
          onClick: async () => {
            if (!activeWallet) {
              throw new Error("No active wallet");
            }
            setSafeConnectError(false);
            setSwitchError(false);
            setSwitchingNetwork(true);
            try {
              await switchChain(safeChainId);
            } catch (e) {
              setSwitchError(true);
            } finally {
              setSwitchingNetwork(false);
            }
          },
          children: [" ", switchingNetwork ? "Switching" : "Switch Network", switchingNetwork && /*#__PURE__*/jsx(Spinner, {
            size: "sm",
            color: "primary"
          })]
        }) : /*#__PURE__*/jsxs(Button, {
          variant: "inverted",
          type: "submit",
          style: {
            display: "flex",
            alignItems: "center",
            gap: spacing.sm
          },
          children: [connectionStatus === "connecting" ? "Connecting" : "Connect to Safe", connectionStatus === "connecting" && /*#__PURE__*/jsx(Spinner, {
            size: "sm",
            color: "inverted"
          })]
        })
      }), switchingNetwork && requiresConfirmation && /*#__PURE__*/jsx(ConfirmMessage, {
        children: " Confirm in your wallet "
      })]
    })]
  });
};
const ConfirmMessage = styled.p`
  font-size: ${fontSize.sm};
  color: ${p => p.theme.link.primary};
  text-align: right;
`;
const NetworkSelect = styled.select`
  width: 100%;
  padding: ${spacing.sm};
  box-sizing: border-box;
  outline: none;
  border: none;
  border-radius: 6px;
  color: ${p => p.theme.text.neutral};
  background: transparent;
  font-size: ${fontSize.md};
  box-shadow: 0 0 0 1.5px ${p => p.theme.input.outline};
  appearance: none;

  &:focus {
    box-shadow: 0 0 0 2px ${p => p.theme.input.focusRing};
  }

  &:invalid {
    color: ${p => p.theme.text.secondary};
  }
  &[data-error="true"] {
    box-shadow: 0 0 0 1.5px ${p => p.theme.input.errorRing};
  }

  &[disabled] {
    opacity: 1;
    cursor: not-allowed;
  }
`;
const StyledChevronDownIcon = styled(ChevronDownIcon)`
  color: ${p => p.theme.icon.secondary};
`;

const safeWallet = config => {
  const personalWallets = config?.personalWallets || defaultWallets;
  return {
    id: SafeWallet.id,
    meta: SafeWallet.meta,
    create: options => new SafeWallet({
      ...options
    }),
    connectUI(props) {
      return /*#__PURE__*/jsx(SafeConnectUI, {
        ...props,
        personalWallets: personalWallets
      });
    },
    isInstalled() {
      return false;
    },
    personalWallets: personalWallets
  };
};
const SafeConnectUI = props => {
  const activeWallet = useWallet();
  const [personalWalletConfig, setPersonalWalletConfig] = useState();
  const disconnect = useDisconnect();
  if (personalWalletConfig) {
    const _props = {
      close: () => {
        setPersonalWalletConfig(undefined);
        props.close(false); // do not reset
      },

      goBack: () => {
        setPersonalWalletConfig(undefined);
      },
      isOpen: props.isOpen,
      open: props.open,
      theme: props.theme,
      walletConfig: personalWalletConfig,
      supportedWallets: props.personalWallets,
      selectionData: props.selectionData,
      setSelectionData: props.setSelectionData
    };
    if (personalWalletConfig.connectUI) {
      return /*#__PURE__*/jsx(personalWalletConfig.connectUI, {
        ..._props
      });
    }
    return /*#__PURE__*/jsx(HeadlessConnectUI, {
      ..._props
    });
  }
  if (!activeWallet) {
    return /*#__PURE__*/jsx(SelectpersonalWallet, {
      personalWallets: props.personalWallets,
      onBack: props.goBack,
      safeWallet: props.walletConfig,
      selectWallet: setPersonalWalletConfig,
      renderBackButton: props.supportedWallets.length > 1
    });
  }
  return /*#__PURE__*/jsx(SelectAccount, {
    onBack: disconnect,
    onConnect: props.close,
    safeWalletConfig: props.walletConfig
  });
};

export { SafeConnectUI, safeWallet };
